//import http from "../http-common";
import BaseService from "./base.service";
import http from "../http-common";
import { getResponseData, customizeError, checkEnterpriseId, getResponseQuery } from "../helpers/_functions";

class WorkedHoursTypesService extends BaseService {
  constructor() {
    super("worked-hours-types");
  }

  getAllByEnterprise() {
    const enterpriseId = checkEnterpriseId();
    return http
        .get(`${this.path}/listAll/${enterpriseId}`)
        .then(res => getResponseData(res))
        .catch((err) => Promise.reject(customizeError(err)));
  }
  checkDuplication(defaultSelected, computedAuthorizedEmployees=[], excludeId = "") {
      const enterpriseId = checkEnterpriseId();
      return getResponseQuery(
        http.post(`${this.path}/check-duplication`, {
          defaultSelected,
          enterpriseId,
          computedAuthorizedEmployees,
          excludeId,
        }),
      );
    }
}

export default new WorkedHoursTypesService();
